import * as React from "react";

import "./user-search-field.scss";

import {userSearch} from "@Common/ui-components/searchable-select/user-search";

import {getInfoTip} from "../common/get-info-tip";

export const UserSearchField = ({textField, cc, findTf}) => {
    try {
        let idBranch = '';
        let mappedFieldName = cc.bindingData?.[textField.side]?.[textField.name]?.value;
        let mappedOfficeResult = findTf(mappedFieldName);
        if (mappedOfficeResult) {
            try {
                let value = JSON.parse(mappedOfficeResult.value);
                idBranch = value.idBranch;
            } catch (e) {
            }
        }
        let idAgent = ''
        let agentBranch = ''
        try {
            let value = JSON.parse(textField.value);
            idAgent = value.idAgent;
            agentBranch = value.idBranch;
        } catch (e) {
            idAgent = ''
        }
        return (
            <div className="relative edit-form-search-3c6">
                {userSearch(textField, idAgent, idBranch, 0, agentBranch)}
                {getInfoTip(textField, cc.sourceData)}
            </div>
        )
    } catch (e) {
        console.log("failed", textField);
        return null;
    }
};
